import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';

import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { TransactionsHistoryComponent } from './transactions-history.component';


@NgModule({
  declarations: [TransactionsHistoryComponent, ],
  imports: [
    FeaturesCommonModule,
    AgGridModule.withComponents([]),
  ],
  exports: [TransactionsHistoryComponent]
})
export class TransactionsModule { }
